module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tab', {
    attrs: {
      "line-width": 3
    },
    model: {
      value: (_vm.wday),
      callback: function($$v) {
        _vm.wday = $$v
      },
      expression: "wday"
    }
  }, _vm._l((_vm.weekLabels), function(weekLabel, wday) {
    return _c('tab-item', {
      key: wday,
      staticClass: "vux-center",
      attrs: {
        "selected": _vm.activeLabel === weekLabel
      },
      on: {
        "click": function($event) {
          _vm.activeLabel = weekLabel
        }
      }
    }, [_vm._v(_vm._s(weekLabel))])
  })), _vm._v(" "), _c('swiper', {
    attrs: {
      "height": "720px",
      "show-dots": false
    },
    model: {
      value: (_vm.wday),
      callback: function($$v) {
        _vm.wday = $$v
      },
      expression: "wday"
    }
  }, _vm._l((_vm.weekLabels), function(weekLabel, wday) {
    return _c('swiper-item', {
      key: wday
    }, [(((_vm.schedules && _vm.schedules[wday] !== undefined) && (Object.keys(_vm.keyedCourses).length > 0))) ? _c('group', _vm._l((_vm.schedules[wday].cells), function(cell) {
      return _c('cell', {
        key: cell.courseinstance_id,
        attrs: {
          "title": _vm.keyedCourses[cell.courseinstance_id].course.name,
          "inline-desc": _vm.keyedCourses[cell.courseinstance_id].teacher.name,
          "link": ("/course/" + (cell.courseinstance_id))
        }
      }, [_c('p', {
        staticClass: "vertical-middle"
      }, [_vm._v(_vm._s(cell.periods_text[0]))]), _vm._v(" "), _c('p', {
        staticClass: "vertical-middle"
      }, [_vm._v(_vm._s(cell.periods_text[1]))])])
    })) : _vm._e()], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a56a359"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Schedule.vue
// module id = 549
// module chunks = 1